<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section
    [theme]="'background-alternative'"
    [themeFlush]="true"
  >
    <dgx-components-grid-container>
      <dgx-components-card
        [spacing]="5"
        class="mb-5 marketing-preferences__container"
      >
        <dgx-components-grid-row>
          <dgx-components-grid-column>
            <h1 class="marketing-preferences__title">
              {{ vm.cmsData.pageTitle }}
            </h1>
            <h2
              [innerHTML]="
                vm.cmsData.pageSubtitle
                  | dgxInterpolate
                    : {
                        privacyPolicy: vm.selectedQuotes | cmsBrandPrivacyPolicy
                      }
              "
              class="typog-body marketing-preferences__subtitle"
            ></h2>
          </dgx-components-grid-column>
        </dgx-components-grid-row>
        <dgx-components-grid-row>
          <dgx-components-grid-column>
            <checkout-marketing-preferences-form
              (submitted)="cs.onFormSubmit($event)"
              class="marketing-preferences__form"
            />
          </dgx-components-grid-column>
        </dgx-components-grid-row>
      </dgx-components-card>
      <dgx-components-button-navigate-back />
    </dgx-components-grid-container>
  </dgx-components-grid-section>

  <div [content]="main" editable-area></div>
</ng-container>
